import {MyopMessageKey} from "../common/MyopMessages";
import {uuidv4} from "../utils/utils";
import {IMyopComponent} from "../host";
import {IRefConfig} from "../common";

export class MessageDirection {
    static down = 'down' as const
    static up = 'up' as const
}

export type MessageDirectionOption = 'up' | 'down';

export abstract class BaseMyopMessage<T = any> {
    id = uuidv4()

    static create<T, U extends new (...args: ConstructorParameters<U>) => T = typeof this>(
        this: U,
        ...args: ConstructorParameters<U>
    ): InstanceType<typeof this> {
        // @ts-ignore
        return new this(...args);
    }

    constructor() {
        //console.log('meesage id created', this.id, document.location.href);
    }

    myop = true

    abstract messageType: MyopMessageKey | string;

    content?: T

    // TODO : cant be optional 
    source?: string
    destination?: string

    route?: string[]

    ref?: Ref

    direction?: MessageDirectionOption

    cleanable: boolean = false

    isTypeof(msg: BaseMyopMessage): boolean {
        return msg.messageType === this.messageType
    }
}

export abstract class MyopElementMessage<T = any> extends BaseMyopMessage<T> {
    constructor(public ref: Ref) {
        super()
    }
}

export abstract class MyopBindReplayMessage<T = any> extends BaseMyopMessage<T> {
    constructor(public replayToHandler?: string) {
        super();
    }
}

export abstract class MyopBindMessage<T = any, R extends MyopBindReplayMessage = any> extends BaseMyopMessage<T> {

    public abstract replyMessageKey: MyopMessageKey;

    public handlerUniqueId = uuidv4()

    constructor(public handler: (message: R) => void) {
        super()
    }
}

export class Ref {
    public myop = true;

    public __nonProxied?: Ref;

    static create(selector: string, refConfig?: IRefConfig, component?: IMyopComponent) {
        let _refConfig = refConfig;
        if (!_refConfig) {
            _refConfig = {
                id: '',
                name: '',
                description: '',
                selectorType: 'id-attribute',
                selector: selector,
                behavior: {
                    type: 'code'
                }
            } as IRefConfig
        }
        return new Ref(_refConfig, component);
    }

    constructor(public refConfig: IRefConfig, public component?: IMyopComponent) {
        this.__nonProxied = {
            ...this,
            component: null // in order to be serializable
        }
    }
}
